import productList from '../utils/products'
import styles from './DashDetail.module.scss'
import { useLocation } from 'react-router-dom'
import { getLangName as t } from '../utils/index'
import u21 from '../assets/images/home/21.png'
import u22 from '../assets/images/home/22.png'
import u23 from '../assets/images/home/23.png'
import u24 from '../assets/images/home/24.png'
import u491 from '../assets/images/home/25.png'
import { Carousel } from 'antd';

import { useState } from 'react';
function DashboardDetail() {
  const [key, seyKEy] = useState('1');
  return <div className={styles.dashDetail}>
    <div className={styles.dashDetailBasic}>
      <Carousel autoplay style={{
        width:'600px',
        height:'500px'
      }}>
        <div className={styles.asd}>
           <img src={u21} />
        </div>
        <div className={styles.asd}>
           <img src={u22} />
        </div>
        <div className={styles.asd}>
           <img src={u23} />
        </div>
        <div className={styles.asd}>
           <img src={u24} />
        </div>
      </Carousel>
      {/* <img src={u21} /> */}
      <div className={styles.dashDetail_basic}>
        <div className={styles.dashDetail_basic_title}>
        软件版BMS
        </div>
        <div className={styles.dashDetail_basic_nsd}>{t('ProductDescription')}: </div>
        <div className={styles.dashDetail_basic_nsd}>{t('SupportedSeries')}: 17~24串</div>
        <div className={styles.dashDetail_basic_nsd}>{t('BatteryType')}: 三元锂、铁锂</div>
        <div className={styles.dashDetail_basic_nsd}>{t('SupportedCurrent')}: 30~80A</div>
        <div className={styles.dashDetail_basic_nsd}>{t('ProductDimensions')}: 200mm × 150mm × 50mm</div>
        <div className={styles.dashDetail_basic_nsd}>{t('ProductCategory')}: 动力电池BMS</div>
        <div className={styles.dashDetail_basic_nsd}>{t('ProductFeatures')}: 过充保护、过放保护、温度控制、短路保护</div>
      </div>
    </div>
    <div className={styles.dashDetail_info}>
      <div className={styles.newsBox}>
        <div className={styles.newsBox_tab}>
          <div className={
            key === '1' ? styles.newsBox_tab_item_active : styles.newsBox_tab_item
          } onClick={() => seyKEy('1')}>{t('DetailIntroduction')}</div>
          {/* <div className={

              key === '2' ? styles.newsBox_tab_item_active : styles.newsBox_tab_item
            } onClick={() => seyKEy('2')}>{t('IndustryNews')}</div> */}
        </div>
      </div>
      <div className={styles.sd}>
        <img src={u491} />
      </div>
    </div>
  </div>;
}

export default DashboardDetail;